import styled from 'styled-components';
import { TransformedAssetClassForecastValueDto } from '../../../../types';
import TableRow from './tableRow';
import SubTotalRow from './tableSubTotalRow';

interface TableBodyProps {
  contributionsTableData: TransformedAssetClassForecastValueDto[];
  distributionsTableData: TransformedAssetClassForecastValueDto[];
  columnWidth: number;
  targetSubAssetClasses: boolean;
}

const TableBody = ({ contributionsTableData, distributionsTableData, columnWidth, targetSubAssetClasses }: TableBodyProps) => {
  return (
    <TableBodyWrapper>
      <ContributionsRowWrapper>Contributions</ContributionsRowWrapper>
      {contributionsTableData.map((row) => (
        <TableRow key={row.name} row={row} columnWidth={columnWidth} targetSubAssetClasses={targetSubAssetClasses} />
      ))}
      <SubTotalRow tableData={contributionsTableData} columnWidth={columnWidth} />
      <ContributionsRowWrapper>Distribution</ContributionsRowWrapper>
      {distributionsTableData.map((row) => (
        <TableRow key={row.name} row={row} columnWidth={columnWidth} targetSubAssetClasses={targetSubAssetClasses} />
      ))}
      <SubTotalRow tableData={distributionsTableData} columnWidth={columnWidth} />
    </TableBodyWrapper>
  );
};

const TableBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ContributionsRowWrapper = styled.div`
  border-radius: 4px;
  background: ${({ theme }) => theme.layer[3]};
  padding: 10px 24px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22.4px;
  color: ${({ theme }) => theme.layer.base};
`;

export default TableBody;
